<div class="frame-parent-wash">
  <div *ngIf="!resumeSelected && !selectedWashType">
    <div class="title-wrapper" >
      <div class="title">
        <div class="title1">{{ 'wash_specialized_centers_description' | translate}}</div>
      </div>
    </div>

    <div
      class="service-icon-circle-text-parent"
    >
      <div *ngFor="let item of selectedItemCards">
        <div
          class="service-icon-circle-text"
          id="serviceIconCircleText"
          (click)="selectService(item)"
        >
          <div class="services-iconsservice-icon">
            <img class="services-icons" alt="" [src]="item.icon" />
          </div>
          <div class="transfer">{{ item.title | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="frame-parent" *ngIf="resumeSelected && selectedWashType">
    <div class="frame-group">
      <div class="title-parent">
        <div class="title">
          <div class="title1">{{ resumeSelected.titulo | translate }}</div>
        </div>
        <div class="tag">
          <img class="custom-icons" alt="" src="assets/icons/clock-icon.svg" />
          <div class="text">{{ 'to-consult' | translate }}</div>
                  <img src="assets/icons/cash-icon.svg" class="to-consult-price-icon" />
        <span>{{ summaryData.TotalOrderAmount }}€</span>
        </div>
      </div>
      <div class="dale-a-tu">
        {{ resumeSelected.descripcion | translate }}
      </div>
    </div>
    <div class="requisitos">
      <div class="title">
        <div class="title1">{{ 'what-includes' | translate }}</div>
      </div>
      <div class="tag-parent">
        <div class="tag1" *ngFor="let item of resumeSelected.incluye">
          <img
            class="iconsoutlinecheck-circle"
            alt=""
            src="assets/icons/check-circle.svg"
          />
          <div class="text1">
           {{ item | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="title-group">
      <div class="title">
        <div class="title1">{{ 'how-does-it-work' | translate }}</div>
      </div>
      <div class="tag-parent">
        <div class="tag1" *ngFor="let item of resumeSelected.funcionamiento">
          <img class="iconsoutlinecheck-circle" [alt]="item.text" [src]="'assets/icons/' + item.icon + '.svg'" />
          <div class="text1">
            {{ item.text | translate }}
          </div>
        </div>
      </div>
    </div>
    
    <div class="seguro">
      <div class="text7">
        <img class="logo-icon" alt="" src="assets/icons/mapfre-logo.svg" />
        <div class="card-title-parent">
          <div class="card-title">
            <div class="card-title1">{{ 'breathe-easy' | translate }}</div>
          </div>
          <div class="card-title">
            <div class="descripcin">
              {{ 'breathe-easy-text' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="requisitos">
      <div class="title">
        <div class="title1">{{ 'requirements-for-solicitude' | translate }}</div>
      </div>
      <div class="tag-parent">
        <div class="tag4" *ngFor="let item of resumeSelected.requisitos">
          <img class="iconsoutlinecheck-circle" alt="" [alt]="item.text" [src]="'assets/icons/' + item.icon + '.svg'" />
          <div class="text1">{{ item.text | translate }}</div>
        </div>
      </div>
    </div>
    <div class="legal-text">
      <div class="lorem-ipsum">
        <span [innerHTML]="'legal-text' | translate"></span>
      </div>
    </div>
    <div class="title-container">
      <div class="title8">
        <div class="title9">{{ 'service-price' | translate }}</div>
      </div>
      <div class="instance-wrapper">
        <div class="price-wrapper">
          <div class="price">{{ summaryData.TotalOrderAmount }}€</div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <ng-content select="[left-button]"></ng-content>
    
      <button
        class="continue-button2"
        (click)="submitForm()"
      >
        Continuar
      </button>
    </div>
  </div>

  <!-- <div *ngIf="resumeSelected && selectedWashType">
    <h2>{{ resumeSelected.titulo }}</h2>
    <p>{{ resumeSelected.descripcion }}</p>
  
    <h3>¿Qué incluye?</h3>
    <ul>
      <li *ngFor="let item of resumeSelected.incluye">{{ item }}</li>
    </ul>
  
    <h3>¿Cómo funciona?</h3>
    <ul>
      <li *ngFor="let paso of resumeSelected.funcionamiento">{{ paso }}</li>
    </ul>
  
    <h3>Requisitos para solicitar el servicio</h3>
    <ul>
      <li *ngFor="let requisito of resumeSelected.requisitos">{{ requisito }}</li>
    </ul>
  
    <p><strong>Precio del servicio:</strong> {{ resumeSelected.precio }}€</p>
  
    <button (click)="back()">Atrás</button>
  </div> -->
</div>
